(function ($) {
    $(document).ready(function () {
        featuresIconsCarousel();
    });
    function featuresIconsCarousel(){
        var carousel_wrapper = $('.features_icons_carousel_wrap'),
            elements = carousel_wrapper.find('.item-wrap'),
            hasCarousel = false;

        if(is_phone && elements.length > 1){
            hasCarousel = true;
        } else if(is_mobile && elements.length > 2){
            hasCarousel = true;
        } else{
            if(elements.length > 3){
                hasCarousel = true;
            }
        }

        if(carousel_wrapper.length > 0 && hasCarousel){
            carousel_wrapper.not('.slick-initialized').slick({
                rows: 0,
                slidesToShow: 3,
                slidesToScroll: 3,
                centerMode: true,
                rtl: $('html').attr('dir') === 'rtl',
                infinite: true,
                arrows: true,
                dots: true,
                prevArrow: accor_arrow_prev,
                nextArrow: accor_arrow_next,
                customPaging: function(slider, i) {
                    return $('<button type="button" />');
                },
                centerPadding: '180px',
                responsive:[
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            centerPadding: '90px'
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            centerPadding: '45px',
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '0',
                        }
                    },
                ]
            });
        }
    }
})(jQuery);